import { PendingItemDto } from '@act/shared/data-transfer-objects';
import { Badge, FlexContainer } from '@act/storybook';
import { usePendingItemSelector } from 'redux/utils/selectors/pending-item-selectors';
import { Typography } from '@mui/material';

const PendingTitle = ({ memberId }: { memberId: string }) => {
  const pendingItems: PendingItemDto[] =
    usePendingItemSelector.pendingItemsForMember(memberId, []);

  return (
    <FlexContainer direction="row" alignItems="center">
      <Typography variant="bodyMedium">Pending events</Typography>
      <Badge badgeContent={pendingItems?.length || 0} color="neutral" inline />
    </FlexContainer>
  );
};

export default PendingTitle;
